import { FeaturedArticleInputs } from './FeaturedArticle';

export const featuredArticleTransformer = (node): FeaturedArticleInputs => {
    return {
        title: node.field_articletitle,
        text: node.field_articletext.value,
        cta: {
            text: node.field_articlelink.title,
            uri: node.field_articlelink.uri,
        },
        image: {
            gatsbyImage: 
                node.relationships.field_articleimage.localFile,
            alt: node.field_articleimage.alt,
        },
    };
};
